/* eslint-disable complexity */
/* eslint-disable max-statements */
/* eslint-disable max-lines */
import { useEffect } from "react"
import { Routers } from "../../../../../../../constant/Routers"
import { AxiosErrorType } from "../../../../../../../infrastructure/axiosError/models"
import {
  TravelersListDataType,
  UseTravelersListType,
} from "../../../../models/list"
import { useVariables } from "../useVariables"
import { backToLogin } from "../../../../../../../utils/backToLogin"
import { pushStateError } from "../../../../../../../utils/pushStateError"
import { TravelersListDataSourceType } from "../../../../models/list/data"
import { convertDataSource } from "./convertDataSource"
import { travelerApi } from "../../../../apis"
import { getValueByLanguage } from "../../../../../../../utils/getValueByLanguage"
import { departmentsApi } from "../../../../../../../infrastructure/handlers/departments"
import { DepartmentsResType } from "../../../../../../../infrastructure/handlers/departments/models"
import { OptionItemType } from "../../../../../../../_webui/layout/components/Select/models"
import { convertDataSearch } from "./convertDataSearch"
import { countriesApi } from "../../../../../../../infrastructure/handlers/countries"
import { AllCountriesResType } from "../../../../../../../infrastructure/handlers/countries/models"
import { GeneralCode } from "../../../../../../../constant/GeneralCode"
import { generalMastersApi } from "../../../../../../../infrastructure/handlers/generalMasters"
import { GeneralMastersResType } from "../../../../../../../infrastructure/handlers/generalMasters/models"
import { RadioChangeEvent } from "antd"
import { TravelerFormSearchFormDataType } from "../../../../components/list/FormSearch/modals"
import { concat } from "../../../../../../../utils/concat"

const { DPTD, JAPAN_COUNTRY_CODE, OTHER } = GeneralCode
const { SCR114_USER_SEARCH, SCR973 } = Routers

export const useTravelersList =
  (): UseTravelersListType<TravelersListDataSourceType> => {
    const {
      allCountries,
      breadcrumbItems,
      cities,
      columns,
      countryCode,
      departments,
      dispatchType,
      form,
      goToSchedulesAdd,
      goToSchedulesAddDraft,
      goToTravelersDelete,
      goToTravelersDetail,
      goToTravelersEditDraft,
      handleExportFile,
      isDisabledBtnDelete,
      isDisabledBtnRefer,
      isHiddenBtnDelete,
      isHiddenBtnExportFile,
      isHiddenBtnRefer,
      isHiddenBtnRegister,
      isHiddenBtnRequestDelete,
      isHiddenBtnScheduleDraft,
      isHiddenBtnTravelerDraft,
      isLoading,
      isLoadingLayout,
      isNotAccessScreen,
      isOpen,
      isOtherCity,
      isOverseasResident,
      isPathnameTravelers,
      isPathnameTravelersUser,
      isPathnameTravelersUserSearch,
      onCancel,
      onChange,
      onChangeTable,
      onOpen,
      pathname,
      perItem,
      push,
      rowSelection,
      setAllCountries,
      setCities,
      setCountryCode,
      setDataSourceExport,
      setDepartments,
      setDispatchType,
      setIsLoading,
      setIsLoadingLayout,
      setIsOtherCity,
      setIsOverseasResident,
      setSearchCondition,
      setTravelerInfo,
      state,
      travelerInfo,
    } = useVariables()

    const onChangeWorkPlaceCity = (value: string) => {
      const _isOtherCity = value === OTHER
      setIsOtherCity(_isOtherCity)
      form.setFieldValue("workPlace", "")
    }

    const onChangeWorkPlaceCountry = (value: string) => {
      onChangeWorkPlaceCity("")
      setCities([])
      setCountryCode(value)
      form.setFieldsValue({
        workPlace: "",
        workPlaceCity: "",
      })
    }

    const onChangeWorkPlaceLocation = (event: RadioChangeEvent) => {
      const { value } = event.target
      setIsOverseasResident(value === 1)
    }

    const onClickReset = () => {
      setIsOtherCity(false)
      setCountryCode("")
      setIsOverseasResident(false)
      setCities([])
      setTimeout(() => {
        form.setFieldValue("workPlaceLocation", "")
      })
    }

    const callApi = () => {
      // APIを呼び出し、「派遣種別（詳細）」のデータ一覧を取得する。
      const getGeneralMaster: Promise<GeneralMastersResType[]> =
        generalMastersApi.getGeneralMaster(DPTD)
      // APIを呼び出し、部門一覧情報を取得し
      const getAllDepartments: Promise<DepartmentsResType[]> =
        departmentsApi.getAllDepartments()
      // APIを呼び出し、「国」コンボボックスの表示一覧を取得する。
      const getAllCountries: Promise<AllCountriesResType[]> =
        countriesApi.getAllCountries()

      Promise.all([getGeneralMaster, getAllDepartments, getAllCountries])
        .then((res) => {
          const dispatchTypeList: OptionItemType[] = res[0].map((item) => ({
            text: String(getValueByLanguage(item.value1, item.value2)),
            value: item.key1,
          }))
          const departmentList: OptionItemType[] = res[1].map((item) => ({
            text: getValueByLanguage(
              item.departmentNameJapan,
              item.departmentNameEnglish,
            ).toString(),
            value: item.bumonCd,
          }))
          const allCountryList: OptionItemType[] = res[2]
            .map((item) => ({
              text: item.countryName,
              value: item.countryCode,
            }))
            .filter((item) => item.value !== JAPAN_COUNTRY_CODE)

          setDispatchType(dispatchTypeList)
          setAllCountries(allCountryList)
          setDepartments(departmentList)
        })
        .catch((error: AxiosErrorType) => {
          const state = pushStateError(error)
          push({ pathname: SCR973, state })
        })
        .finally(() => {
          if (!state?.searchCondition) {
            setIsLoadingLayout(false)
          }
        })
    }

    const onLoadData = (values: TravelerFormSearchFormDataType) => {
      const dataConvert = convertDataSearch(
        pathname === SCR114_USER_SEARCH,
        values,
      )
      // 渡航者情報一覧を取得する。
      const data = values
        ? dataConvert
        : convertDataSearch(
            pathname === SCR114_USER_SEARCH,
            state?.searchCondition,
          )
      setSearchCondition({
        ...values,
        workPlace: concat(values?.workPlace),
        workPlaceCity: concat(values?.workPlaceCity),
        workPlaceCountry: concat(values?.workPlaceCountry),
      })

      travelerApi
        .browseTravelers(data)
        .then((res: TravelersListDataType[]) => {
          const _res = convertDataSource(res)
          // 画面上の渡航者情報初期表示処理を行う。
          setTravelerInfo(_res)
          setDataSourceExport(res)
          setIsLoading(false)
          setIsLoadingLayout(false)
        })
        .catch((error: AxiosErrorType) => {
          // 「SCR973_エラー情報の表示画面」に遷移する。
          const stateError = pushStateError(error)
          push({ pathname: SCR973, state: stateError })
        })
    }

    const onFinish = (values: TravelerFormSearchFormDataType) => {
      setIsLoading(true)
      onLoadData(values)
    }

    useEffect(() => {
      // ユーザの画面アクセス許可チェックを処理する。
      if (isNotAccessScreen) {
        // 「SCR973_エラー情報の表示画面」に遷移する。
        const { pathname, state } = backToLogin()
        push({ pathname, state })
      } else {
        callApi()
        if (state?.searchCondition) {
          form.setFieldsValue(state.searchCondition)
          const { workPlaceCity, workPlaceCountry, workPlaceLocation } =
            form.getFieldsValue()
          const _isOtherCity = workPlaceCity === OTHER

          setIsOtherCity(_isOtherCity)
          setCountryCode(workPlaceCountry)
          setIsOverseasResident(workPlaceLocation === 1)
          onLoadData(state.searchCondition)
        } else {
          form.setFieldValue("workPlaceLocation", "")
        }
      }
    }, [])

    return {
      allCountries,
      breadcrumbItems,
      cities,
      columns,
      countryCode,
      dataSource: travelerInfo,
      departments,
      dispatchType,
      form,
      goToSchedulesAdd,
      goToSchedulesAddDraft,
      goToTravelersDelete,
      goToTravelersDetail,
      goToTravelersEditDraft,
      handleExportFile,
      isDisabledBtnDelete,
      isDisabledBtnRefer,
      isHiddenBtnDelete,
      isHiddenBtnExportFile,
      isHiddenBtnRefer,
      isHiddenBtnRegister,
      isHiddenBtnRequestDelete,
      isHiddenBtnScheduleDraft,
      isHiddenBtnTravelerDraft,
      isLoading,
      isLoadingLayout,
      isOpen,
      isOtherCity,
      isOverseasResident,
      isPathnameTravelers,
      isPathnameTravelersUser,
      isPathnameTravelersUserSearch,
      onCancel,
      onChange,
      onChangeTable,
      onChangeWorkPlaceCity,
      onChangeWorkPlaceCountry,
      onChangeWorkPlaceLocation,
      onClickReset,
      onFinish,
      onOpen,
      perItem,
      rowSelection,
    }
  }
